import React from "react";
import { Button, CircularProgress, ButtonProps } from "@mui/material";

interface SubmitButtonProps extends ButtonProps {
  text?: string;
  loading?: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  text = "Submit",
  loading = false,
  disabled,
  className,
  ...rest
}) => {
  return (
    <Button
      type="submit"
      variant="contained"
      color="primary"
      className={className}
      loading={loading}
      disabled={disabled || loading}
      {...rest}
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : rest.startIcon}
    >
      {loading ? `${text}` : text}
    </Button>
  );
};

export default SubmitButton;
